// extracted by mini-css-extract-plugin
export var actionButton = "_6g-1";
export var actionButtons = "_6g-2";
export var actions = "_6g-0";
export var aiUnread = "_6g-10";
export var alignCenter = "_6g-h";
export var backWrapper = "_6g-3";
export var cellContainer = "_6g-4";
export var checkboxContainer = "_6g-5";
export var contentContainer = "_6g-6";
export var contentHeader = "_6g-8";
export var conversationsTableWrapper = "_6g-s";
export var draftReplyBadgeContainer = "_6g-m";
export var dropdownItem = "_6g-b";
export var dropdownItemsContainer = "_6g-a";
export var dropdownTitle = "_6g-c";
export var errorIcon = "_6g-7";
export var filter = "_6g-d";
export var gray = "_6g-i";
export var headerActionButtons = "_6g-e";
export var headerCheckboxContainer = "_6g-f";
export var icon = "_6g-j";
export var menuContainer = "_6g-k";
export var noMoreTicketsIcon = "_6g-12";
export var noMoreTicketsSubText = "_6g-13";
export var oneLine = "_6g-l";
export var optionsButton = "_6g-n";
export var plus = "_6g-o";
export var portalButtonsWrapper = "_6g-g";
export var red = "_6g-p";
export var scrolledTop = "_6g-9";
export var search = "_6g-q";
export var selectedConversationsCount = "_6g-r";
export var spinner = "_6g-t";
export var strong = "_6g-u";
export var summaryCell = "_6g-v";
export var tableContainer = "_6g-11";
export var tagContainer = "_6g-w";
export var threeDots = "_6g-x";
export var twoLines = "_6g-y";
export var unread = "_6g-z";